import React from 'react';
import { Link } from 'react-router';
import { Helmet } from 'react-helmet';
import Moment from 'moment';
import AppRoutes from '../../routes/logged-in';
import Loading from '../../components/loading/loading';
import AccountDownloadLink from './account-download-button';
import './user-details.scss';

export default class UserDetailsModern extends React.Component {
  render() {
    const {
      account_type,
      created_at,
      name,
      email,
      receive_messages,
      free_trial_expired,
      free_trial_expires_at,
      loading,
      successNotice,
      handleSubmit,
      upgradable, // Pass as a rendered element or render prop
      handleMessageChange
    } = this.props;

    return (
        <div className="settings-modern-page">
            <Helmet>
                <title>Neurochecklists | Your profile</title>
            </Helmet>

            <div className="settings-form-wrap">

                <div className="settings-page-header">
                    <h1 className="section-title">Your Profile</h1>
                    <p className="section-sub">Manage your account details and subscription preferences.</p>
                </div>

                {successNotice}

                <form onSubmit={handleSubmit}>
                    {loading ? <Loading text="Updating..." /> : null}

                    <div className="settings-card">
                        <div className="settings-meta-row">
                            <span className="meta-label">Account Type</span>
                            <div className="meta-value-group">
                                <div className="meta-value">
                                    {account_type}
                                    {upgradable}
                                </div>
                                {account_type === 'Starter' && (
                                    <span className="meta-hint">
                                        {free_trial_expired
                                            ? '(Free trial expired)'
                                            : `(Expires ${Moment(free_trial_expires_at).format('D MMM YYYY')})`}
                                    </span>
                                )}
                            </div>
                        </div>
                        <div className="settings-meta-row">
                            <span className="meta-label">Member Since</span>
                            <span className="meta-value">{Moment(created_at).format('D MMMM, YYYY')}</span>
                        </div>
                        <div className="settings-meta-row">
                            <span className="meta-label">Password</span>
                            <Link to={AppRoutes.changePassword} className="meta-link">Change password</Link>
                        </div>
                    </div>

                    <div className="input-group settings-input-row">
                        <label className="input-label" htmlFor="name">Full Name</label>
                        <input
                            ref={this.props.nameRef}
                            id="name"
                            className="input-field"
                            type="text"
                            defaultValue={name}
                            required
                        />
                    </div>

                    <div className="input-group settings-input-row">
                        <label className="input-label" htmlFor="email">Email Address</label>
                        <input
                            ref={this.props.emailRef}
                            id="email"
                            className="input-field"
                            type="email"
                            defaultValue={email}
                            onChange={this.props.handleEmailChange}
                            required
                        />
                    </div>

                    {this.props.emailChanged && (
                        <div className="input-group settings-input-row">
                            <label className="input-label" htmlFor="current_password">Current Password (required to change your email)</label>
                            <input
                                ref={this.props.currentPasswordRef}
                                id="current_password"
                                className="input-field"
                                type="password"
                                autoComplete="current-password"
                                required
                            />
                        </div>
                    )}

                    <div className="settings-checkbox-row">
                        <input
                            ref={this.props.receiveMessagesRef}
                            id="receive_messages"
                            type="checkbox"
                            checked={receive_messages == 1}
                            onChange={handleMessageChange}
                        />
                        <label htmlFor="receive_messages">Subscribe to system messages and updates</label>
                    </div>

                    <div className="settings-form-actions">
                        <div className="actions-left">
                            <AccountDownloadLink />
                            <Link to={AppRoutes.deleteAccount}>Delete my account</Link>
                        </div>
                        <button type="submit" className="btn btn-primary-sm">Save Changes</button>
                    </div>
                </form>
            </div>
        </div>
    );
  }
}
